import { buildReduxMapBundle } from "seneca-common/utils/state/build-redux-bundles";

import { FEATURE_NAME } from "./consts";
import Parent, { ParentFromServerType } from "./models/state/Parent";

export const { actionTypes, actions, reducer } = buildReduxMapBundle({
  featureName: FEATURE_NAME,
  getIdFromJsObject: (parent: ParentFromServerType) => parent.userId,
  jsToImmutableTransform: (parent: ParentFromServerType) => {
    const { userId, ...rest } = parent;
    return new Parent({ ...rest, id: userId });
  }
});
